const RES = window.RES

import ApiLoader from './loaders/ApiLoader'
import YoutubeLoader from './loaders/YoutubeLoader'

const urlTools = require('./url')

class Shared {
  constructor() {
    this.locale = document.documentElement.getAttribute('lang')
      ? document.documentElement.getAttribute('lang').replace(/-/, '_')
      : 'en_US'

    this.googleMapsAPIKey = RES.get('googleMaps', 'apiKey')
    this.googleMaps = new ApiLoader(
      `https://maps.googleapis.com/maps/api/js?key=${this.googleMapsAPIKey}`,
      'google.maps'
    )
    this.youtube = new YoutubeLoader()
    this.vimeo = new ApiLoader(`https://player.vimeo.com/api/player.js`, 'Vimeo')
    this.facebook = new ApiLoader(`https://connect.facebook.net/${this.locale}/sdk.js`, 'FB')
    this.facebook.onloadListener((FB) => {
      FB.init({
        appId            : RES.get('facebook', 'appID'),
        autoLogAppEvents : true,
        xfbml            : true,
        version          : 'v2.11'
      });
    })
  }
  get urlTools() { return urlTools }

  isMobileDevice() {
    return !!navigator.userAgent.match(/Android|iPhone|iPad/)
  }
}

let shared = null
/**
 * @type {Shared}
 */
export default (function() {
  if (!shared) shared = new Shared()
  return shared
}())


